import React from "react";

import { Grid, Typography } from "@material-ui/core";

import Page from "components/admin/Page";

import AddAdmin from "./AddAdmin";
import FilterAdmins from "./FilterAdmins";
import AdminsTable from "./AdminsTable";

import { selectUserInfo } from "modules/auth/authSlice";
import { useAppSelector } from "store";

const Admins: React.FC = () => {
    const userInfo = useAppSelector(selectUserInfo);

    return (
        <Page dataCy="pages-admin-admins">
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <br />
                    <Typography variant="subtitle1" component="div" color="textSecondary">
                        KPMG Admin - {userInfo.firstName} {userInfo.lastName}
                    </Typography>
                    <Typography variant="h3" component="div">
                        Admins
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={4} alignItems="center">
                        <Grid item xs={2}>
                            <AddAdmin />
                        </Grid>
                        <Grid item xs={3}>
                            <FilterAdmins />
                        </Grid>
                        <Grid item xs={7} />
                        <Grid item xs={12}>
                            <AdminsTable />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Page>
    );
};

export default Admins;
